import { Avatar, Box, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../global/config/store";
import { Logout } from "@mui/icons-material";
import { useState } from "react";
import { logout } from "../../global/config/Reducer/authSlice";
import { useLocation } from "react-router-dom";
import { routeConfig } from "../../Routes/routeConfig";

function Header() {
    const user = useSelector((state: RootState) => state.auth.user);
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const location = useLocation();
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const getTitle = () => {
        const route = routeConfig
            .slice()
            .sort((a, b) => b.path.length - a.path.length)
            .find((r) => location.pathname.startsWith(r.path));

        return route?.title || "-";
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg justify-content-between px-2 py-0 header">
                <Typography variant="h5" fontWeight={700} className="text-white px-2">{getTitle()}</Typography>
                <Box className="d-flex align-items-center h-100" gap={2}>
                    {/* <NotificationsOutlined sx={{ fill: "#898989" }} /> */}
                    <Box className="p-2 d-flex align-items-center h-100" onClick={handleClick} sx={{ cursor: "pointer" }} gap={2} >
                        <Avatar className="bg-dark-color text-white" src={user?.profile_pic} sx={{ width: "32px", height: "32px" }} />
                        <Typography className="text-white fs-24">{user?.firstName} {user?.lastName}</Typography>
                        <ExpandMoreIcon sx={{ fill: "white" }} />
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        slotProps={{
                            paper: {
                                elevation: 0,
                                sx: {
                                    bgcolor: "#141414",
                                    color: "#FFFFFF",
                                    minWidth: 220,
                                    borderRadius: "8px",
                                    mt: 1.5,
                                    boxShadow: "0px 8px 24px rgba(0,0,0,0.6)",
                                    overflow: "visible",
                                    border: "1px solid #fff",

                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        right: 18,
                                        width: 10,
                                        height: 10,
                                        bgcolor: "#141414",
                                        transform: "translateY(-50%) rotate(45deg)",
                                        borderLeft: "1px solid #ffffff",
                                        borderTop: "1px solid #ffffff",
                                    },
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <Box px={2} py={1.5} className="d-flex flex-column align-items-center justify-content-center">
                            <Typography fontWeight={600} fontSize={18}>
                                {user?.firstName} {user?.lastName}
                            </Typography>

                            <Typography fontSize={14} sx={{ color: "#9E9E9E", mt: 0.2 }}>
                                SUPER_ADMIN
                            </Typography>
                        </Box>
                        <MenuItem
                            onClick={() => { dispatch(logout()) }}
                            sx={{
                                py: 1.5,
                                fontSize: 14,
                                color: "#E0E0E0",
                                "&:hover": {
                                    bgcolor: "#2A2A2A",
                                },
                            }}
                        >
                            <ListItemIcon>
                                <Logout fontSize="medium" sx={{ color: "#E0E0E0" }} />
                            </ListItemIcon>
                            <span style={{ fontSize: "16px" }}>Logout</span>
                        </MenuItem>
                    </Menu>
                    {/* <YellowIcon /> */}
                </Box>
            </nav>
        </>
    )
}

export default Header;